import { stringifyUrl } from "query-string";
import { memo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { DropdownMenuItem } from "~/application/components/DropdownMenu";
import { NavLink } from "~/components/Link";

export type NavItemLinkProps = {
  href: string;
  title: string;
  children: React.ReactNode;
};

export const NavItemLink = memo(({ href, children, title }: NavItemLinkProps) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const orderType = searchParams.get("orderType");

  const url = stringifyUrl({
    url: location.pathname,
    query: {
      orderType: orderType ? orderType : undefined,
    },
  });

  const isNowActive = href.split("#")[0] === url;

  return (
    <NavLink to={href} title={title}>
      <DropdownMenuItem data-active={isNowActive}>{children}</DropdownMenuItem>
    </NavLink>
  );
});

NavItemLink.displayName = "NavItemLink";
